/** A stable id for this browser on this device — used to recognise the host's
 * own phone on join and offer them "Become host" instead of a student seat. */
const KEY = "udyog_device_id";

export function getDeviceId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `d-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function deviceLabel() {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "My iPhone";
  if (/Android/i.test(ua)) return "My Android phone";
  if (/Mac/i.test(ua)) return "My Mac";
  if (/Windows/i.test(ua)) return "My Windows PC";
  return "My device";
}
